import {
  Component,
  Input,
  Output,
  EventEmitter,
  Optional,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Inject, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "../../../services/dialog.service";
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "swap-cetip-error",
  templateUrl: "./swap-cetip-error.component.html",
  styleUrls: ["./swap-cetip-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class SwapCetipErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsSwapCetip: string[] = [
    "portfolioDocument",
    "portfolioName",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioCetipAccount",
    "operationValue",
    "expirationDate",
    "command",
    "activeIndex",
    "activeIndexPercent",
    "activeIndexTax",
    "activeIndexBase",
    "activeInterestType",
    "passiveIndex",
    "passiveIndexPercent",
    "passiveIndexTax",
    "passiveIndexBase",
    "passiveInterestType",
    "isNewCounterpart",
    "counterpartName",
    "counterpartDocument",
    "counterpartCetipAccount",
  ];

  ngOnInit(): void {}
}
